// this static page with faucet ui is available at https://anvil.gearbox.foundation/forks/<executionId>/faucet

import type { NetworkType } from "@gearbox-protocol/sdk/onchain";

// RELATIVE_ENDPOINT should resolve to https://anvil.gearbox.foundation/forks/<executionId> in this case
export const URL_BASE =
  import.meta.env.VITE_URL_BASE ?? new URL(import.meta.url).origin;

export const LIVE_NETWORKS: NetworkType[] = [
  "Mainnet",
  "Monad",
  "Etherlink",
  "Plasma",
  "Somnia",
];

console.info(`Will use URL base: ${URL_BASE}`);
